import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUser, isAuthenticated, logout as authLogout } from '../services/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    const authenticated = isAuthenticated();
    setIsAuth(authenticated);
    
    if (authenticated) {
      const userData = getUser();
      setUser(userData);
    }
    setLoading(false);
  };

  const login = (userData) => {
    setUser(userData);
    setIsAuth(true);
  };

  const logout = () => {
    authLogout();
    setUser(null);
    setIsAuth(false);
  };

  // Refresh user data
  const refreshUser = async () => {
    try {
      const userData = getUser();
      if (userData) {
        setUser(userData);
      }
    } catch (error) {
      console.error('Error refreshing user:', error);
    }
  };

  // Check if user has admin privileges
  const isAdmin = () => {
    return user?.is_admin === true;
  };

  // Get user's display name
  const getDisplayName = () => {
    if (!user) return 'Guest';
    return user.email?.split('@')[0] || 'User';
  };

  const value = {
    user,
    loading,
    isAuth,
    login,
    logout,
    checkAuth,
    refreshUser,
    isAdmin,
    getDisplayName
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;